import { useParams } from 'react-router-dom';
import { PublicationStatusRedirect } from 'src/components/PublicationStatusRedirect/PublicationStatusRedirect';
import { useMenu } from 'src/hooks/useMenu/useMenu';
import { Routes } from 'src/routes';

export const MenuPublicationStatus = () => {
  const { menuId } = useParams<{ menuId: string }>();
  const { data: menu, isLoading } = useMenu(menuId ?? '', { enabled: !!menuId });

  if (!menuId) {
    throw new Error('MenuPublicationStatus rendered without a menuId route param');
  }

  return (
    <PublicationStatusRedirect
      isLoading={isLoading}
      name={menu?.name}
      eventId={menu?.publication.eventId}
      listLabel="Menus"
      listPath={Routes.MENUS}
      notPublishedMessage="This menu has not been published"
    />
  );
};
